import { ModuleConfig } from "@core/interfaces";

const config: ModuleConfig = {
  name: "Busk",
  baseUrl: "",
  routes: [
    {
      path: "/admin/busk/sellers",
      page: "BuskSeller",
      title: "Busk Admin seller",
      exact: true,
    },
  ],
  requireAuthenticated: true,
};

export default config;
